import api from "Helpers/Api";

export default async function fairDelete(fairId: string) {
  const { data } = await api.delete(`/fairs/delete/${fairId}`);

  return data;
}
